module.exports = __webpack_public_path__ + "img/yjyj.dfb4e51a.png";